module.exports = __webpack_public_path__ + "img/question.c1d4c227.svg";